import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

export interface DataLayerEventPayload {
  event_category: string;
  [event_key: string]: unknown;
}

export interface DatalayerVisitPayload {
  event_category: string;
  user_login_mode?: string;
  [event_key: string]: unknown;
}

export interface DatalayerTrackingClient {
  trackVisit: (data: DatalayerVisitPayload) => void;
  trackEvent: (data: DataLayerEventPayload) => void;
  save: (
    item: Record<string, string | number | boolean | undefined | null>,
  ) => void;
}

interface DatalayerTrackingProviderProps {
  datalayerTrackingClient: DatalayerTrackingClient;
  children: ReactNode;
}

const mockDatalayerTrackingClient: DatalayerTrackingClient = {
  trackVisit: () => {},
  trackEvent: () => {},
  save: () => {},
};

export const useDatalayerTracking = () => useContext(datalayerTrackingContext);

const datalayerTrackingContext = createContext<DatalayerTrackingClient>(
  mockDatalayerTrackingClient,
);

export const DatalayerTrackingProvider = ({
  datalayerTrackingClient,
  children,
}: DatalayerTrackingProviderProps) => (
  <datalayerTrackingContext.Provider value={datalayerTrackingClient}>
    {children}
  </datalayerTrackingContext.Provider>
);
